"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clipboard = require("clipboard-polyfill");
var Notification_1 = require("../utils/Notification");
var ClipboardUtils = /** @class */ (function () {
    function ClipboardUtils() {
    }
    /**
     * Copies a URL to the clipboard. Must be called from within an
     * event handler such as click.
     */
    ClipboardUtils.copyUrlToClipboard = function (url, successMessage) {
        var item = new clipboard.ClipboardItem({
            'text/html': new Blob(["<a href=\"" + url + "\">" + url + "</a>"], { type: 'text/html' }),
            'text/plain': new Blob([url], { type: 'text/plain' }),
        });
        this.copyToClipboard(item, successMessage);
    };
    /**
     * Copies plain text to the clipboard. Must be called from within an
     * event handler such as click.
     */
    ClipboardUtils.copyTextToClipboard = function (text, successMessage) {
        var item = new clipboard.ClipboardItem({
            'text/plain': new Blob([text], { type: 'text/plain' }),
        });
        this.copyToClipboard(item, successMessage);
    };
    /**
     * Copies data to the clipboard.
     */
    ClipboardUtils.copyToClipboard = function (item, successMessage) {
        var successCallback = function () {
            Notification_1.Notification.Instance.showInfo(successMessage);
        };
        var failureCallback = function () {
            // Do nothing for now
        };
        this.clipboardWriteImpl([item]).then(successCallback, failureCallback);
    };
    /**
     * For unit test mocking
     */
    ClipboardUtils.overrideClipboardWriteImpl = function (newWriteImpl) {
        this.clipboardWriteImpl = newWriteImpl;
    };
    ClipboardUtils.clipboardWriteImpl = clipboard.write;
    return ClipboardUtils;
}());
exports.ClipboardUtils = ClipboardUtils;
//# sourceMappingURL=ClipboardUtils.js.map